import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHeadFromPage } from "@/config/seoHead";
import { scrapedPageQueryOptions } from "@/hooks/useScrapedPage";
import { lookupSlug, notFoundUnlessRedirected } from "@/lib/slugGuards";

const DynamicContentPage = lazy(() => import("@/components/common/DynamicContentPage"));

export const Route = createFileRoute("/pressreleaser/$slug")({
  // Ladda innehållet i SSR så sidan inte hoppar till efter hydrering.
  loader: async ({ params, context }) => {
    const path = `/pressreleaser/${params.slug}`;
    const page = await lookupSlug(() => context.queryClient.ensureQueryData(scrapedPageQueryOptions(path)));
    // null = pressreleasen finns inte (404); undefined = uppslagningen misslyckades, rendera ändå.
    if (page === null) await notFoundUnlessRedirected(path);
    return { page };
  },
  head: ({ params, loaderData }) =>
    seoHeadFromPage(`/pressreleaser/${params.slug}`, loaderData?.page, { ogType: "article" }),
  component: PressreleaseDetaljRoute,
});

function PressreleaseDetaljRoute() {
  const { page } = Route.useLoaderData();
  return (
    <DynamicContentPage
      basePath="/pressreleaser"
      sectionLabel="Pressreleaser"
      sectionPath="/pressreleaser"
      type="post"
      initialPage={page}
    />
  );
}
